import {
  FlightGuestProps,
  FlightTripType,
  PlaneTakeOffTimeMapType,
} from './types';

export const ADULT_MAX_NUMBER = 6;
export const ADULT_DEFAULT_NUMBER = 1;
export const ADULT_MIN_NUMBER = 1;
export const CHILD_MAX_NUMBER = 3;
export const CHILD_DEFAULT_NUMBER = 0;
export const INFANT_MAX_NUMBER = 3;
export const INFANT_DEFAULT_NUMBER = 0;
export const MAX_PASSENGER_NUMBER = 6;

export const NUMBER_OF_MONTHS_DATES_OUTSIDE_RANGE = 12;

export const initialGuestInfo: FlightGuestProps = {
  numberOfAdultGuests: ADULT_DEFAULT_NUMBER,
  numberOfChildGuests: CHILD_DEFAULT_NUMBER,
  numberOfInfantGuests: INFANT_DEFAULT_NUMBER,
};

export const LIST_FLIGHTS_PAGE_SIZE = 2000;
export const ITEMS_PER_PAGE = 20;

export const getGuestMaxNumberErrorMessage = (
  guest: string,
  maxNumber: number
) => `${guest} sayısı en fazla ${maxNumber} olabilir.`;

export const getTotalGuestNumberErrorMessage = (count = MAX_PASSENGER_NUMBER) =>
  `Bir seferde bebek hariç en fazla ${count} yolcu için işlem yapılabilir.`;

export type FlightTripOption = { value: FlightTripType; label: string };
export const flightTripOptions: FlightTripOption[] = [
  { value: 'round-trip', label: 'Gidiş-Dönüş' },
  { value: 'one-way', label: 'Tek Yön' },
];

export const DURATION_TIME = {
  hour: 'saat',
  minute: 'dakika',
  shortHour: 'sa',
  shortMinute: 'dk',
};

export const FLIGHT_LEG = {
  '0': 'Gidiş',
  '1': 'Dönüş',
};

export const FLIGHT_CLASS_CODE_NAME_MAP: Record<string, string> = {
  C: 'Business',
  M: 'Economy',
  X: 'Economy',
  Y: 'Economy',
  W: 'Economy',
};

export const FLIGHT_PRICE_RANGE_FILTER_KEY = 'priceRange';

export const PLANE_TAKEOFF_TIME_MAP: PlaneTakeOffTimeMapType = {
  EARLY_MORNING: {
    key: 'EARLY_MORNING',
    value: 'Sabaha Karşı',
    subTitle: '00:00 - 04:59',
  },
  MORNING: {
    key: 'MORNING',
    value: 'Sabah',
    subTitle: '05:00 - 11:59',
  },
  AFTERNOON: {
    key: 'AFTERNOON',
    value: 'Öğleden Sonra',
    subTitle: '12:00 - 17:59',
  },
  EVENING: {
    key: 'EVENING',
    value: 'Akşam',
    subTitle: '18:00 - 23:59',
  },
};

export const FLIGHT_DIRECTION = {
  OUT_BOUND: 0,
  IN_BOUND: 1,
};

export const FLIGHT_DIRECTION_NAME = {
  OUT_BOUND: 'Gidiş Uçuşu',
  IN_BOUND: 'Dönüş Uçuşu',
  ABROAD_ROUND_TRIP: 'Uçuşunuzu',
};

export const FLIGHT_SEARCH_QUERY_PARAM_KEYS = {
  departureAirportCode: 'dep',
  departureDate: 'ddate',
  arrivalAirportCode: 'arr',
  returnDate: 'rdate',
  departureIsCity: 'depIsCity',
  arrivalIsCity: 'arrIsCity',
  isDomestic: 'IsDomestic',
  isDirectFlight: 'out-stops',
  isOneWay: 'IsOneWay',
  adults: 'ADT',
  childs: 'CHD',
  infants: 'INF',
};

export const FLIGHT_FILTER_QUERY_PARAM_KEYS = {
  TIMES: 'times',
  STOPS: 'stops',
  DEPARTURE_AIRPORTS: 'depAirports',
  CLAZZES: 'classes',
  AIRLINES: 'airlines',
  MIN_PRICE: 'minPrice',
  MAX_PRICE: 'maxPrice',
  BAGGAGE: 'baggage',
};

export const OUTBOUND_FLIGHT_FILTER_QUERY_PARAM_KEYS: Record<string, string> =
  {};
Object.entries(FLIGHT_FILTER_QUERY_PARAM_KEYS).forEach(([key, value]) => {
  OUTBOUND_FLIGHT_FILTER_QUERY_PARAM_KEYS[key] = 'out-' + value;
});

export const INBOUND_FLIGHT_FILTER_QUERY_PARAM_KEYS: Record<string, string> =
  {};
Object.entries(FLIGHT_FILTER_QUERY_PARAM_KEYS).forEach(([key, value]) => {
  INBOUND_FLIGHT_FILTER_QUERY_PARAM_KEYS[key] = 'in-' + value;
});

export const FLIGHT_SORT_DATA = [
  { id: 'lowest-price', label: 'Fiyat (En Düşük)' },
  { id: 'shortest-time', label: 'Süre (En Kısa)' },
  { id: 'departure-time', label: 'Kalkış (En Erken)' },
  { id: 'arrival-time', label: 'Varış (En Erken)' },
];

export const POPULAR_FLIGHTS = [
  {
    airportId: 9715,
    airportCode: 'IST',
    airportName: 'İstanbul Havalimanı',
    cityCode: 'IST',
    cityName: 'İstanbul',
    countryCode: 'TR',
    countryName: 'Turkey',
    isCity: false,
  },
  {
    airportId: 72,
    airportCode: 'ADB',
    airportName: 'Adnan Menderes Havalimanı',
    cityCode: 'IZM',
    cityName: 'İzmir',
    countryCode: 'TR',
    countryName: 'Turkey',
    isCity: false,
  },
  {
    airportId: 504,
    airportCode: 'AYT',
    airportName: 'Antalya Havalimanı',
    cityCode: 'AYT',
    cityName: 'Antalya',
    countryCode: 'TR',
    countryName: 'Turkey',
    isCity: false,
  },
  {
    airportId: 2041,
    airportCode: 'ECN',
    airportName: 'Ercan Lefkoşa Havalimanı',
    cityCode: 'ECN',
    cityName: 'Lefkoşa - Kıbrıs',
    countryCode: 'TR',
    countryName: 'Turkey',
    isCity: false,
  },
  {
    airportId: 268,
    airportCode: 'AMS',
    airportName: 'Schiphol Airport Havalimanı',
    cityCode: 'AMS',
    cityName: 'Amsterdam',
    countryCode: 'NL',
    countryName: 'Netherlands',
    isCity: false,
  },
  {
    airportId: 0,
    airportCode: 'PAR',
    airportName: 'Tüm Havalimanları',
    cityCode: 'PAR',
    cityName: 'Paris',
    countryCode: 'FR',
    countryName: 'FR',
    isCity: true,
  },
];

/**
 * Without stops and classes
 */
export const {
  STOPS,
  CLAZZES,
  ...FLIGHT_FILTER_QUERY_PARAM_KEYS_WITHOUT_STOPS_AND_CLASSES
} = FLIGHT_FILTER_QUERY_PARAM_KEYS;

export const OUTBOUND_FLIGHT_FILTER_QUERY_PARAM_KEYS_WITHOUT_STOPS_AND_CLASSES: Record<
  string,
  string
> = {};
Object.entries(
  FLIGHT_FILTER_QUERY_PARAM_KEYS_WITHOUT_STOPS_AND_CLASSES
).forEach(([key, value]) => {
  OUTBOUND_FLIGHT_FILTER_QUERY_PARAM_KEYS_WITHOUT_STOPS_AND_CLASSES[key] =
    'out-' + value;
});

export const INBOUND_FLIGHT_FILTER_QUERY_PARAM_KEYS_WITHOUT_STOPS_AND_CLASSES: Record<
  string,
  string
> = {};
Object.entries(
  FLIGHT_FILTER_QUERY_PARAM_KEYS_WITHOUT_STOPS_AND_CLASSES
).forEach(([key, value]) => {
  INBOUND_FLIGHT_FILTER_QUERY_PARAM_KEYS_WITHOUT_STOPS_AND_CLASSES[key] =
    'in-' + value;
});
